module.exports = __webpack_public_path__ + "img/member08.ba953721.png";